import React from 'react';
import { Bell } from 'lucide-react';

interface MessagesBadgeProps {
  unreadCount: number;
  onClick: () => void;
  hasUrgent?: boolean;
}

/**
 * Badge de mensagens para o footer
 */
export function MessagesBadge({ unreadCount, onClick, hasUrgent = false }: MessagesBadgeProps) {
  return (
    <button
      onClick={onClick}
      className="relative p-1.5 text-gray-400 hover:text-white transition-colors flex-shrink-0 z-50"
      title={unreadCount > 0 ? `${unreadCount} mensagem${unreadCount > 1 ? 'ns' : ''} não lida${unreadCount > 1 ? 's' : ''}` : 'Mensagens e Notificações do Sistema'}
      type="button"
    >
      <Bell className="w-4 h-4" />
      
      {unreadCount > 0 && (
        <span
          className={`absolute -top-0.5 -right-0.5 min-w-[16px] h-[16px] px-1 rounded-full text-[9px] font-bold flex items-center justify-center leading-none ${
            hasUrgent
              ? 'bg-red-500 text-white animate-pulse shadow-lg shadow-red-500/50'
              : 'bg-red-500 text-white shadow-md'
          }`}
          style={{ 
            zIndex: 1000,
            pointerEvents: 'none'
          }}
        >
          {unreadCount > 99 ? '99+' : unreadCount}
        </span>
      )}
      
      {hasUrgent && unreadCount === 0 && (
        <span 
          className="absolute top-0 right-0 w-2 h-2 bg-red-500 rounded-full animate-pulse shadow-lg shadow-red-500/50"
          style={{ zIndex: 1000 }}
        />
      )}
    </button>
  );
}

